import Vue from "vue";
import store from '@/store/index';
import sanctumApi from "@/auth/sanctum/sanctumApi";

let instance;

/** Returns the current instance of the SDK */
export const getInstance = () => instance;

/** Creates an instance of the Sanctum Auth plugin. If one has already been created, it returns that instance */
export const useSanctumAuth = (router) => {
    if (instance) return instance;

    // The 'instance' is simply a Vue object
    instance = new Vue({
        router,
        data() {
            return {
                loading: false, //true
                error: null,
                user : null
            };
        },
        methods: {
            async logout() {
                this.loading = true;
                this.error = null;
                try {
                    await sanctumApi.logout();
                    await store.dispatch('setUserLoggedOut');
                    await this.navigateToHomeScreen();
                } catch (error) {
                    this.error = error;
                }finally{
                    this.loading = false
                }
            },
            async login($credentials) {
                this.loading = true;
                this.error = null;
                var response = null;
                try {
                    await sanctumApi.createSession();
                    response = await sanctumApi.login($credentials);
                } catch (e) {
                    this.error = e;
                }finally{
                    this.loading = false
                }

                return response;
            },
            async setAuthenticatedAndContinue($user) {
                await store.dispatch('setUserAuthenticated');
                await store.dispatch('setCurrentUser', $user);
                await store.dispatch('getUserLocation');
                this.user = $user;
                await this.navigateToHomeScreen();
            },
            async sendTwoFactorChallenge($code) {
                this.loading = true;
                this.error = null;
                var response = null;
                try {
                    response = await sanctumApi.verifyTwoFactorChallenge({code: $code});
                } catch (e) {
                    this.error = e;
                }finally{
                    this.loading = false
                }
                return response;
            },
            //THIS IS USED FOR SAVING PREVIOUS CLIENT/PROJECT DATA Nothing Critical used with this...
            async getUser() {
                this.loading = true;
                this.error = null;
                var $user = await store.getters.currentUser;
                if(!$user){
                    try {
                        let response = await sanctumApi.getCurrentUser();
                        await store.dispatch('setCurrentUser', response.data);
                        this.user = response.data
                    } catch (e) {
                        this.error = e;
                    }
                }
                this.loading = false
            },
            async navigateToHomeScreen(){
                await this.$router.push({name: 'home'}).catch(error => {
                    if (
                        error.name !== 'NavigationDuplicated' &&
                        !error.message.includes('Avoided redundant navigation to current location')
                    ) {
                        window.console.log(error)
                    }
                })
            }

        },
        computed: {
            isAuthenticated() {
                return store.getters.authenticated;
            },
            userKnown(){
                return (store.getters.currentUser)? true : false;
            }
        },
        async created() {
        }
    });

    return instance;
}

export const SanctumAuthPlugin = {
    install(Vue, router) {
        Vue.prototype.$auth = useSanctumAuth(router);
    }
}